import React, { Component } from 'react';

import CircularProgress from 'material-ui/CircularProgress';
import IconButton from 'material-ui/IconButton';
import DownloadIcon from 'material-ui/svg-icons/file/cloud-download';

import Papa from 'papaparse';

class DownloadAsCsvButton extends Component {
  constructor() {
    super();
    this.state = { csvLoading: false };
  }

  handleDownloadCsv = async () => {
    this.setState({ csvLoading: true });

    try {
      const csvDataArray = await this.props.dataPromise();
      const csv = Papa.unparse(csvDataArray);
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, this.props.exportedFilename);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', this.props.exportedFilename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }

      this.setState({ csvLoading: false });
    } catch (error) {
      console.error(error);
      this.setState({ csvLoading: false });
    }
  };

  render() {
    const { csvLoading } = this.state;
    const { tooltip } = this.props;
    return (
      <IconButton
        tooltip={tooltip}
        tooltipPosition="top-center"
        onClick={this.handleDownloadCsv}
        disabled={csvLoading}
      >
        {csvLoading ? (
          <CircularProgress size={24} thickness={2} />
        ) : (
          <DownloadIcon />
        )}
      </IconButton>
    );
  }
}

export default DownloadAsCsvButton;



// WEBPACK FOOTER //
// ./src/components/common/DownloadAsCsvButton/DownloadAsCsvButton.js